import React from 'react';
import { Button } from '../components/ui/Button';
import { ArrowRight, ShieldCheck, Lock } from 'lucide-react';
export function CheckoutPage() {
  const handleCheckout = () => {
    window.location.href = 'https://www.fanbasis.com/agency-checkout/true-marketer/D9Vl5';
  };
  return <div className="min-h-screen w-full flex flex-col items-center justify-center bg-[#FAFAFA] p-4" data-id="element-11">
      <div className="w-full max-w-md bg-white rounded-2xl shadow-xl border border-gray-100 overflow-hidden" data-id="element-12">
        {/* Header Section */}
        <div className="p-8 sm:p-10 text-center space-y-6" data-id="element-13">
          <div className="space-y-2" data-id="element-14">
            <h1 className="text-3xl font-bold tracking-tight text-gray-900" data-id="element-15">
              INFO COMMERCE AI BOOTCAMP
            </h1>
            <p className="text-gray-500 text-lg" data-id="element-16">Acceso Completo al Programa</p>
          </div>

          <div className="py-6" data-id="element-17">
            <div className="text-sm uppercase tracking-wider text-emerald-600 font-semibold mb-2" data-id="element-18">
              Precio Especial
            </div>
            <div className="text-5xl font-bold text-gray-900 tracking-tight" data-id="element-19">
              $297
            </div>
          </div>

          <Button onClick={handleCheckout} size="lg" className="w-full text-lg font-semibold h-16" rightIcon={<ArrowRight className="w-5 h-5" data-id="element-21" />} data-id="element-20">
            Comprar Ahora
          </Button>

          <div className="flex justify-center" data-id="element-22">
            <img src="https://cdn.magicpatterns.com/uploads/8GHLD8cnKemDdH9UnjFrey/IMG_2925.jpg" alt="or 4 payments of $75.75 with Zip" className="h-8 object-contain" data-id="element-23" />
          </div>

          <p className="text-xs text-gray-400 mt-4" data-id="element-24">
            Serás redirigido a nuestra página de pago segura.
          </p>
        </div>

        {/* Trust Indicators */}
      </div>

      {/* Footer minimal */}
      <div className="mt-8 text-center text-gray-400 text-sm" data-id="element-25">
        &copy; {new Date().getFullYear()} Info Commerce AI Bootcamp. Todos los
        derechos reservados.
      </div>
    </div>;
}